var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loaded)?_c('div',{staticClass:"section-wrapper"},[_c('div',{staticClass:"section-title"},[_vm._v("1.3 变更记录")]),_c('div',{staticClass:"table",staticStyle:{"margin-top":"0"}},[_c('ChangeLogMoreTable',{attrs:{"data":_vm.entityJson,"ChangeLogLength":this.ChangeLogLength}})],1)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }